import { gql } from '@apollo/client'

const WELCOME_BACK_CARD_QUERY = gql`
  query WelcomeBackCardQuery {
    user {
      id
      firstName
      subscription {
        id
        nextEditableBox {
          id
          cutOffDate
          amendable
        }
      }
    }
  }
`

export { WELCOME_BACK_CARD_QUERY }
